// Vendors
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const CANCEL_DROP_MODAL_COMPONENT_PROPS = {
  'blocked': true,
  'contentScrollArias': {
    'aria-label': 'Content Scroll',
  },
  'customWidthAllDevices': true,
  'data-testid': 'cancel-drop-modal-component',
  'open': true,
  'variant': VARIANTS.ModalContainerVariantType.DEFAULT,
};
const CANCEL_DROP_MODAL_MOBILE_BREAKPOINT_WIDTH = 1200;
const CANCEL_DROP_MODAL_MAX_WIDTH = '720px';
const RESIZE_EVENT = 'resize';

export {
  CANCEL_DROP_MODAL_COMPONENT_PROPS,
  CANCEL_DROP_MODAL_MAX_WIDTH,
  CANCEL_DROP_MODAL_MOBILE_BREAKPOINT_WIDTH,
  RESIZE_EVENT,
};
